import { Yii } from "libraries/interfaces/Yii";
import { ILabels } from "libraries/interfaces/ILabels";

export const FILTER_COMPONENT: ILabels = {
    filters: Yii.t('wui-iqba-js', 'Filtres'),
};

export const FILTER_LABEL: ILabels = {
    beginPlusOrMinus: Yii.t('wui-iqba-js', "Flexibilité"),
    cost: Yii.t('wui-iqba-js', "Prix d'achat"),
    retail: Yii.t('wui-iqba-js', "Prix de vente"),
    fareType: Yii.t('wui-iqba-js', "Type de tarif"),
    from: Yii.t('wui-iqba-js', "Aéroport de départ"),
    to: Yii.t('wui-iqba-js', "Aéroport d'arrivée"),
    begin: Yii.t('wui-iqba-js', "Horaire de départ"),
    end: Yii.t('wui-iqba-js', "Horaires d'arrivée"),
    duration: Yii.t('wui-iqba-js', "Durée"),
    durationStop: Yii.t('wui-iqba-js', "Durée de correspondance"),
    stop: Yii.t('wui-iqba-js', "Nombre de correspondances"),
    carrier: Yii.t('wui-iqba-js', "Compagnie"),
    via: Yii.t('wui-iqba-js', "Aéroport de correspondance"),
    host: Yii.t('wui-iqba-js', "Source"),
    carbonFootprint: Yii.t('wui-iqba-js', "CO\u2082"),
    rating: Yii.t('wui-iqba-js','Note'),
};
